// Change stay location (crew's home / hotel stay address) popup and its address picker, moved unchanged from
// CrewActivityComponent.js (2026-10-28). Not reachable today: the page keeps its row action switched off
// (ENABLE_CHANGE_STAY_LOCATION in CrewActivityComponent.jsx).
import { SelectBox, CheckBox } from "devextreme-react";
import React, { useState } from "react";
import moment from "moment";
import Modal from "react-modal";
import Swal from "sweetalert2";
import { RegEx } from "../../../helpers/fixcodes";
import { axiosGet, axiosPost } from "../../../apis/useAxios";
import { showErrorMessage } from "../../../helpers/message";

export default function ChangeStayLocationAddress(props) {
  const [state, setState] = useState({
    dropdownAirportDataSource: [],
    stationAirports: [],
    airlineCode: props?.airlineCode || "",
    employeeNumber: props?.employeeNumber || "",
    airportCode: props?.airportCode || "",
    id: props?.id || 0,
    isHotelCancel: props.isHotelCancel,
    isTransporterRequired: props.isTransporterRequired,
    isOpenSelectAddressModal: false,
    crewAddressDropdownDataSource: [],
    latitude: "",
    longitude: "",
    addressId: 0,
    address: "",
    postalCode: "",
    hotelName: "",
    modalErrors: {
      employeeNumber: "",
      airportCode: "",
      airlineCode: "",
      latitude: "",
      longitude: "",
      address: "",
      postalCode: "",
    },
  });
  const GetDropdownAirportDataSource = async () => {
    try {
      const airportDropdownData = await axiosGet(
        `Airport/get-airport-dropdown/${sessionStorage.getItem(
          "session_airlineCode",
        )}`,
      );
      setState((prev) => ({
        ...prev,
        dropdownAirportDataSource: airportDropdownData?.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const GetStationAirports = async () => {
    try {
      const response = await axiosGet(`Crew/get-station_airports`, {
        airportCode: state.airportCode,
      });
      setState((prev) => ({
        ...prev,
        stationAirports: response?.payload ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const isValid = () => {
    let isValid = true;
    try {
      let err = state.modalErrors;
      err.airportCode = "";
      err.latitude = "";
      err.longitude = "";
      err.postalCode = "";
      err.address = "";
      if (!state.airportCode) {
        isValid = false;
        err.airportCode = "Please select airport code";
      }
      if (!state.latitude) {
        isValid = false;
        err.latitude = "Please enter latitude";
      }
      if (!state.longitude) {
        isValid = false;
        err.longitude = "Please enter longitude";
      }
      if (!state.postalCode) {
        isValid = false;
        err.postalCode = "Please enter postal code";
      }
      if (!state.address) {
        isValid = false;
        err.address = "Please enter address";
      } else {
        if (state.addressId === 0) {
          isValid = false;
          err.address = "Please select valid address";
        }
      }

      setState((prev) => ({ ...prev, modalErrors: err }));
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };
  const handleOnChangeStayLocation = async (e) => {
    e.preventDefault();
    try {
      if (isValid()) {
        let request = {};
        request.AirlineCode = state.airlineCode;
        request.AirportCode = state.airportCode;
        request.EmployeeNumber = state.employeeNumber;
        request.CzReservationId = state.id;
        request.IsHotelCancel = state.isHotelCancel;
        request.TransporterRequired = state.isTransporterRequired;
        request.AddressId = state.addressId;
        request.AddressInfo = state.address;
        request.PostalCode = state.postalCode;
        request.Latitude = state.latitude;
        request.Longitude = state.longitude;
        request.DeviceTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        setState((prev) => ({ ...prev, isSubmitted: true }));
        const data = await axiosPost(
          "CrewActivity/change-stay-location",
          request,
        );
        setState((prev) => ({ ...prev, isSubmitted: false }));
        if (data?.isSuccess) {
          await Swal.fire({
            icon: "success",
            title: "Success",
            text: data?.message,
            allowOutsideClick: false,
          }).then(async (result) => {
            if (result.isConfirmed) {
              await props.onRefresh();
              props.onClose();
            }
          });
        } else {
          await showErrorMessage(data?.message);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getCrewAddressList = async () => {
    try {
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      var request = {};
      request.AirlineCode = airlineCode;
      request.EmployeeNo = state.employeeNumber;
      const response = await axiosPost("Crew/get-address", request);
      const data = response?.payload ?? response ?? [];
      const filteredData = data.filter((el) =>
        state.stationAirports.find((element) => element === el.baseStation),
      );

      setState((prev) => ({
        ...prev,
        crewAddressDropdownDataSource: filteredData ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };
  const handelOnAddressChange = (e) => {
    try {
      let err = state.modalErrors;
      err.address = "";
      err.postalCode = "";
      err.latitude = "";
      err.longitude = "";
      const { rowIndex, address, postalCode, latitude, longitude } = {
        ...(e.selectedItem ?? null),
      };
      setState((prev) => ({
        ...prev,
        addressId: rowIndex || 0,
        address: address || "",
        postalCode: postalCode || "",
        latitude: latitude || 0,
        longitude: longitude || 0,
        modalErrors: err,
      }));
    } catch (error) {}
  };
  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        onAfterOpen={async () => {
          await GetStationAirports();
          await getCrewAddressList();
        }}
        onAfterClose={() => {
          setState((prev) => ({
            ...prev,
            dropdownAirportDataSource: [],
            stationAirports: [],
            employeeNumber: "",
            airlineCode: "",
            airportCode: "",
            latitude: "",
            longitude: "",
            id: 0,
            addressId: 0,
            address: "",
            postalCode: "",
            isHotelCancel: false,
            isTransporterRequired: false,
            hotelName: "",
            modalErrors: {
              employeeNumber: "",
              airportCode: "",
              airlineCode: "",
              latitude: "",
              longitude: "",
              address: "",
              postalCode: "",
            },
          }));
        }}
        style={{
          content: {
            width: "55%",
            padding: 0,
            borderRadius: 10,
            overflow: "hidden",
          },
        }}
      >
        {/* Header */}
        <div
          style={{
            background: "linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)",
            padding: "14px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <i
              className={`fas fa-${props?.isHotelDropoff ? "map-marker-alt" : "map-pin"}`}
              style={{ color: "#fff", fontSize: 18 }}
            />
            <div>
              <h6
                style={{
                  margin: 0,
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: 14,
                }}
              >
                {props?.isHotelDropoff
                  ? "Change / Cancel Hotel Drop-off"
                  : "Change / Cancel Hotel Pick-up"}{" "}
                Address
              </h6>
              {props?.hotelName && (
                <span
                  style={{
                    background: "rgba(255,255,255,0.2)",
                    color: "#fff",
                    borderRadius: 20,
                    padding: "2px 10px",
                    fontSize: 11,
                    marginTop: 3,
                    display: "inline-block",
                  }}
                >
                  <i className="fas fa-hotel" style={{ marginRight: 4 }} />
                  {props.hotelName}
                </span>
              )}
            </div>
          </div>
          <button
            type="button"
            onClick={() => props.onClose()}
            style={{
              background: "rgba(255,255,255,0.15)",
              border: "none",
              borderRadius: "50%",
              width: 32,
              height: 32,
              cursor: "pointer",
              color: "#fff",
              fontSize: 15,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <i className="fas fa-times" />
          </button>
        </div>

        {/* Body */}
        <div
          style={{
            padding: "16px 18px",
            background: "#f4f6f9",
            overflowY: "auto",
            maxHeight: "70vh",
            display: "flex",
            flexDirection: "column",
            gap: 12,
          }}
        >
          {/* Crew Info Card */}
          <div
            style={{
              background: "#fff",
              borderRadius: 8,
              padding: "14px 16px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
            }}
          >
            <div
              style={{
                fontSize: 10,
                fontWeight: 700,
                color: "#6c757d",
                letterSpacing: 1,
                marginBottom: 8,
                textTransform: "uppercase",
              }}
            >
              <i
                className="fas fa-id-card"
                style={{ marginRight: 5, color: "#1a73e8" }}
              />
              Crew Information
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="form-group mb-0">
                  <label
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "#495057",
                      marginBottom: 4,
                      display: "block",
                    }}
                  >
                    Staff ID
                  </label>
                  <div className="input-group input-group-sm">
                    <div className="input-group-prepend">
                      <span
                        className="input-group-text"
                        style={{ background: "#e9ecef" }}
                      >
                        <i
                          className="fas fa-id-badge text-muted"
                          style={{ fontSize: 11 }}
                        />
                      </span>
                    </div>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={state.employeeNumber}
                      readOnly
                      style={{
                        background: "#f8f9fa",
                        fontWeight: 600,
                        color: "#343a40",
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="form-group mb-0">
                  <label
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "#495057",
                      marginBottom: 4,
                      display: "block",
                    }}
                  >
                    Pick-up / Drop Airport
                  </label>
                  <div className="input-group input-group-sm">
                    <div className="input-group-prepend">
                      <span
                        className="input-group-text"
                        style={{ background: "#e9ecef" }}
                      >
                        <i
                          className="fas fa-plane text-muted"
                          style={{ fontSize: 11 }}
                        />
                      </span>
                    </div>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={state.airportCode}
                      readOnly
                      style={{
                        background: "#f8f9fa",
                        fontWeight: 600,
                        color: "#343a40",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Location Coordinates Card */}
          <div
            style={{
              background: "#fff",
              borderRadius: 8,
              padding: "14px 16px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
            }}
          >
            <div
              style={{
                fontSize: 10,
                fontWeight: 700,
                color: "#6c757d",
                letterSpacing: 1,
                marginBottom: 8,
                textTransform: "uppercase",
              }}
            >
              <i
                className="fas fa-map-marked-alt"
                style={{ marginRight: 5, color: "#1a73e8" }}
              />
              Location Coordinates
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="form-group mb-0">
                  <label
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "#495057",
                      marginBottom: 4,
                      display: "block",
                    }}
                  >
                    Latitude <span className="text-danger">*</span>
                  </label>
                  <div className="input-group input-group-sm">
                    <div className="input-group-prepend">
                      <span
                        className="input-group-text"
                        style={{
                          background: "#e3f2fd",
                          color: "#1565c0",
                          fontWeight: 700,
                          fontSize: 10,
                          minWidth: 36,
                          justifyContent: "center",
                        }}
                      >
                        LAT
                      </span>
                    </div>
                    <input
                      type="text"
                      className={`form-control form-control-sm${state.modalErrors.latitude ? " is-invalid" : ""}`}
                      placeholder="e.g. 25.2048"
                      value={state.latitude}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.trim() === "" || RegEx.LatLong.test(value)) {
                          setState((prev) => ({ ...prev, latitude: value }));
                        }
                      }}
                    />
                  </div>
                  {state.modalErrors.latitude?.length > 0 && (
                    <div
                      className="text-danger"
                      style={{ fontSize: 11, marginTop: 3 }}
                    >
                      <i
                        className="fas fa-exclamation-circle"
                        style={{ marginRight: 3 }}
                      />
                      {state.modalErrors.latitude}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="form-group mb-0">
                  <label
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "#495057",
                      marginBottom: 4,
                      display: "block",
                    }}
                  >
                    Longitude <span className="text-danger">*</span>
                  </label>
                  <div className="input-group input-group-sm">
                    <div className="input-group-prepend">
                      <span
                        className="input-group-text"
                        style={{
                          background: "#e3f2fd",
                          color: "#1565c0",
                          fontWeight: 700,
                          fontSize: 10,
                          minWidth: 36,
                          justifyContent: "center",
                        }}
                      >
                        LNG
                      </span>
                    </div>
                    <input
                      type="text"
                      className={`form-control form-control-sm${state.modalErrors.longitude ? " is-invalid" : ""}`}
                      placeholder="e.g. 55.2708"
                      value={state.longitude}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.trim() === "" || RegEx.LatLong.test(value)) {
                          setState((prev) => ({ ...prev, longitude: value }));
                        }
                      }}
                    />
                  </div>
                  {state.modalErrors.longitude?.length > 0 && (
                    <div
                      className="text-danger"
                      style={{ fontSize: 11, marginTop: 3 }}
                    >
                      <i
                        className="fas fa-exclamation-circle"
                        style={{ marginRight: 3 }}
                      />
                      {state.modalErrors.longitude}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <div className="form-group mb-0">
                  <label
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "#495057",
                      marginBottom: 4,
                      display: "block",
                    }}
                  >
                    Postal Code <span className="text-danger">*</span>
                  </label>
                  <div className="input-group input-group-sm">
                    <div className="input-group-prepend">
                      <span
                        className="input-group-text"
                        style={{ background: "#e9ecef" }}
                      >
                        <i
                          className="fas fa-envelope text-muted"
                          style={{ fontSize: 11 }}
                        />
                      </span>
                    </div>
                    <input
                      type="text"
                      className={`form-control form-control-sm${state.modalErrors.postalCode ? " is-invalid" : ""}`}
                      placeholder="Enter postal code"
                      value={state.postalCode}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.trim() === "" || value.length <= 7) {
                          setState((prev) => ({ ...prev, postalCode: value }));
                        }
                      }}
                    />
                  </div>
                  {state.modalErrors.postalCode?.length > 0 && (
                    <div
                      className="text-danger"
                      style={{ fontSize: 11, marginTop: 3 }}
                    >
                      <i
                        className="fas fa-exclamation-circle"
                        style={{ marginRight: 3 }}
                      />
                      {state.modalErrors.postalCode}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Address Card */}
          <div
            style={{
              background: "#fff",
              borderRadius: 8,
              padding: "14px 16px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
            }}
          >
            <div
              style={{
                fontSize: 10,
                fontWeight: 700,
                color: "#6c757d",
                letterSpacing: 1,
                marginBottom: 8,
                textTransform: "uppercase",
              }}
            >
              <i
                className="fas fa-map-marker-alt"
                style={{ marginRight: 5, color: "#1a73e8" }}
              />
              Address
            </div>
            <div className="form-group mb-0">
              <label
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#495057",
                  marginBottom: 4,
                  display: "block",
                }}
              >
                Selected Address <span className="text-danger">*</span>
              </label>
              <div className="input-group input-group-sm">
                <input
                  type="text"
                  className={`form-control form-control-sm${state.modalErrors.address ? " is-invalid" : ""}`}
                  placeholder="Click 'Select Address' to choose..."
                  value={state.address}
                  readOnly
                  style={{
                    background: state.address ? "#fff" : "#f8f9fa",
                    cursor: "default",
                  }}
                />
                <div className="input-group-append">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    style={{ fontSize: 12, whiteSpace: "nowrap" }}
                    onClick={async () => {
                      try {
                        setState((prev) => ({
                          ...prev,
                          isOpenSelectAddressModal: true,
                        }));
                        await getCrewAddressList();
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  >
                    <i
                      className="fas fa-search-location"
                      style={{ marginRight: 5 }}
                    />
                    Select Address
                  </button>
                </div>
              </div>
              {state.modalErrors.address?.length > 0 && (
                <div
                  className="text-danger"
                  style={{ fontSize: 11, marginTop: 3 }}
                >
                  <i
                    className="fas fa-exclamation-circle"
                    style={{ marginRight: 3 }}
                  />
                  {state.modalErrors.address}
                </div>
              )}
            </div>
          </div>

          {/* Options Card */}
          <div
            style={{
              background: "#fff",
              borderRadius: 8,
              padding: "14px 16px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
            }}
          >
            <div
              style={{
                fontSize: 10,
                fontWeight: 700,
                color: "#6c757d",
                letterSpacing: 1,
                marginBottom: 8,
                textTransform: "uppercase",
              }}
            >
              <i
                className="fas fa-sliders-h"
                style={{ marginRight: 5, color: "#1a73e8" }}
              />
              Options
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
              {props?.isHotelDropoff && (
                <div
                  style={{
                    flex: "1 1 220px",
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    background: state.isHotelCancel ? "#fff8e1" : "#f8f9fa",
                    border: `1px solid ${state.isHotelCancel ? "#ffc107" : "#dee2e6"}`,
                    borderRadius: 6,
                    padding: "10px 14px",
                    cursor: "pointer",
                    transition: "all 0.15s",
                  }}
                  onClick={() =>
                    setState((prev) => ({
                      ...prev,
                      isHotelCancel: !prev.isHotelCancel,
                    }))
                  }
                >
                  <CheckBox
                    id="isHotelCancel"
                    value={state.isHotelCancel}
                    onValueChanged={(e) =>
                      setState((prev) => ({ ...prev, isHotelCancel: e.value }))
                    }
                  />
                  <label
                    htmlFor="isHotelCancel"
                    style={{
                      margin: 0,
                      cursor: "pointer",
                      fontSize: 13,
                      fontWeight: 500,
                      color: state.isHotelCancel ? "#856404" : "#495057",
                    }}
                  >
                    <i
                      className="fas fa-hotel"
                      style={{
                        marginRight: 5,
                        color: state.isHotelCancel ? "#f0ad4e" : "#6c757d",
                      }}
                    />
                    Cancel Hotel
                  </label>
                </div>
              )}
              <div
                style={{
                  flex: "1 1 220px",
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  background: state.isTransporterRequired
                    ? "#e8f5e9"
                    : "#f8f9fa",
                  border: `1px solid ${state.isTransporterRequired ? "#28a745" : "#dee2e6"}`,
                  borderRadius: 6,
                  padding: "10px 14px",
                  cursor: "pointer",
                  transition: "all 0.15s",
                }}
                onClick={() =>
                  setState((prev) => ({
                    ...prev,
                    isTransporterRequired: !prev.isTransporterRequired,
                  }))
                }
              >
                <CheckBox
                  id="isTransporterRequired"
                  value={state.isTransporterRequired}
                  onValueChanged={(e) =>
                    setState((prev) => ({
                      ...prev,
                      isTransporterRequired: e.value,
                    }))
                  }
                />
                <label
                  htmlFor="isTransporterRequired"
                  style={{
                    margin: 0,
                    cursor: "pointer",
                    fontSize: 13,
                    fontWeight: 500,
                    color: state.isTransporterRequired ? "#155724" : "#495057",
                  }}
                >
                  <i
                    className="fas fa-bus"
                    style={{
                      marginRight: 5,
                      color: state.isTransporterRequired
                        ? "#28a745"
                        : "#6c757d",
                    }}
                  />
                  Transporter Required
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            background: "#fff",
            borderTop: "1px solid #dee2e6",
            padding: "10px 18px",
            display: "flex",
            gap: 8,
            justifyContent: "flex-end",
          }}
        >
          <button
            type="button"
            className="btn btn-primary btn-sm"
            disabled={state.isSubmitted}
            style={{ minWidth: 110, fontWeight: 600 }}
            onClick={async (e) => {
              await handleOnChangeStayLocation(e);
            }}
          >
            {state.isSubmitted ? (
              <>
                <i
                  className="fas fa-spinner fa-spin"
                  style={{ marginRight: 5 }}
                />
                Saving...
              </>
            ) : (
              <>
                <i className="fas fa-save" style={{ marginRight: 5 }} />
                Submit
              </>
            )}
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            style={{ minWidth: 90, fontWeight: 600 }}
            onClick={() => props.onClose()}
          >
            <i className="fas fa-times" style={{ marginRight: 5 }} />
            Close
          </button>
        </div>
      </Modal>

      {state.isOpenSelectAddressModal && (
        <ShowSelectAddressModal
          airportCode={state.airportCode}
          crewAddressDropdownDataSource={state.crewAddressDropdownDataSource}
          addressId={state.addressId}
          handelOnAddressChange={(e) => {
            handelOnAddressChange(e);
          }}
          Close={(isAddressSelected) => {
            if (isAddressSelected) {
              setState((prev) => ({
                ...prev,
                isOpenSelectAddressModal: false,
              }));
            } else {
              setState((prev) => ({
                ...prev,
                addressId: 0,
                isOpenSelectAddressModal: false,
              }));
            }
          }}
        />
      )}
    </>
  );
}
function ShowSelectAddressModal(props) {
  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        style={{
          content: {
            width: "35%",
            padding: 0,
            borderRadius: 10,
            overflow: "hidden",
          },
        }}
      >
        {/* Header */}
        <div
          style={{
            background: "linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)",
            padding: "14px 18px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <i
              className="fas fa-map-marker-alt"
              style={{ color: "#fff", fontSize: 16 }}
            />
            <div>
              <h6
                style={{
                  margin: 0,
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: 14,
                }}
              >
                Select Address
              </h6>
              <span style={{ color: "rgba(255,255,255,0.85)", fontSize: 11 }}>
                Airport: <strong>{props.airportCode}</strong>
              </span>
            </div>
          </div>
          <button
            type="button"
            onClick={() => props.Close(false)}
            style={{
              background: "rgba(255,255,255,0.15)",
              border: "none",
              borderRadius: "50%",
              width: 30,
              height: 30,
              cursor: "pointer",
              color: "#fff",
              fontSize: 14,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <i className="fas fa-times" />
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: "18px 20px", background: "#f4f6f9" }}>
          <div
            style={{
              background: "#fff",
              borderRadius: 8,
              padding: "16px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
            }}
          >
            <label
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: "#495057",
                marginBottom: 6,
                display: "block",
              }}
            >
              <i
                className="fas fa-map-marker-alt"
                style={{ marginRight: 5, color: "#1a73e8" }}
              />
              Choose Address <span className="text-danger">*</span>
            </label>
            <SelectBox
              dataSource={props.crewAddressDropdownDataSource}
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder="Search and select address..."
              name="address"
              value={props.addressId}
              displayExpr="address"
              valueExpr="rowIndex"
              onSelectionChanged={(e) => {
                props.handelOnAddressChange(e);
              }}
              showClearButton={true}
              disabled={false}
              searchEnabled={true}
            />
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            background: "#fff",
            borderTop: "1px solid #dee2e6",
            padding: "12px 18px",
            display: "flex",
            gap: 8,
            justifyContent: "flex-end",
          }}
        >
          <button
            type="button"
            className="btn btn-success btn-sm"
            style={{ minWidth: 130, fontWeight: 600 }}
            onClick={() => props.Close(true)}
          >
            <i className="fas fa-check" style={{ marginRight: 5 }} />
            Select & Close
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            style={{ minWidth: 90, fontWeight: 600 }}
            onClick={() => props.Close(false)}
          >
            <i className="fas fa-times" style={{ marginRight: 5 }} />
            Cancel
          </button>
        </div>
      </Modal>
    </>
  );
}
